module.exports = __webpack_public_path__ + "static/media/pesident.a5f4bd2e.svg";